import {CommunityEventDatesHeader} from '../../ParticipationColumns/CommunityEvents/CommunityEventDates';
import {CommunityTreesDistributedHeader} from '../../ParticipationColumns/Shared/CommunityTreesDistributed';
import { DAMTagHeader } from '../../ParticipationColumns/Shared/DAMTag';
import {DeleteParticipationHeader} from '../../ParticipationColumns/Shared/DeleteParticipation';
import {DollarDonatedHeader} from '../../ParticipationColumns/Shared/DollarDonated';
import {EverythingValidatedHeader} from '../../ParticipationColumns/Shared/EverythingValidated';
import {ProposalHeader} from '../../ParticipationColumns/Shared/ProposalColumn';
import {DemoProjectHeader} from '../../ParticipationColumns/Shared/DemoProjectColumn';
import {ExcludedHeader} from '../../ParticipationColumns/Shared/Excluded';
import {FundedYearHeader} from '../../ParticipationColumns/Shared/FundedYear';
import {FundingSourceHeader} from '../../ParticipationColumns/Shared/FundingSource';
import {ImpactStoryCompletedHeader} from '../../ParticipationColumns/Shared/ImpactStoryCompleted';
import { ImpactStoryInProgressHeader } from '../../ParticipationColumns/Shared/ImpactStoryInProgress';
import {ParticipationIdHeader} from '../../ParticipationColumns/Shared/ParticipationId';
import {PeopleImpactedNumberHeader} from '../../ParticipationColumns/Shared/PeopleImpactedNumber';
import {ProjectIdHeader} from '../../ParticipationColumns/Shared/ProjectId';
import {ProjectNameHeader} from '../../ParticipationColumns/Shared/ProjectName';
import {ProjectTypeHeader} from '../../ParticipationColumns/Shared/ProjectTypeColumn';
import {ReasonForPlantingHeader} from '../../ParticipationColumns/Shared/ReasonForPlanting';
import {VisibleToParticipantHeader} from '../../ParticipationColumns/Shared/VisibleToParticipant';

export function CommunityTreeDistributorParticipationHeader() {
    return (
        <tr>
            <DeleteParticipationHeader />
            <ExcludedHeader />
            <EverythingValidatedHeader />
            <ProposalHeader />
            <DemoProjectHeader />
            <VisibleToParticipantHeader />
            <ParticipationIdHeader />
            <FundedYearHeader />
            <FundingSourceHeader />
            <CommunityTreesDistributedHeader />
            <DollarDonatedHeader />
            <ProjectIdHeader />
            <ProjectTypeHeader />
            <ProjectNameHeader />
            <CommunityEventDatesHeader />
            <ReasonForPlantingHeader />
            <ImpactStoryInProgressHeader />
            <ImpactStoryCompletedHeader />
            <PeopleImpactedNumberHeader />
            <DAMTagHeader />
        </tr>
    );
}
